import styled from "styled-components";

import { Form } from "antd";

const { Item } = Form;

const FormItem = styled(Item)`
    .ant-form-item-row {
        .ant-form-item-label {
            padding-bottom: 2px !important;

            label {
                font-size: 12px;
                line-height: 15px;
                min-height: 15px;
                color: #8c8c8c;
            }
        }
    }
`;

export default FormItem;
